import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import DefaultCPButton from './defaultCommandPanelButton';

function FiltersButton({
  content, onClick, disabled, color,
}) {
  return (
    <DefaultCPButton
      content={content}
      onClick={onClick}
      disabled={disabled}
      icon={<FontAwesomeIcon icon={faFilter} />}
      color={color}
    />
  );
}

FiltersButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  color: PropTypes.string,
};

FiltersButton.defaultProps = {
  content: 'Фільтрування',
  disabled: false,
  color: 'secondary',
};

export default FiltersButton;
